import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from '../api/api'; // Điều chỉnh đường dẫn nếu cần
import './Header.css';

const Header = ({ onCartUpdate }) => {
  const [menuItems, setMenuItems] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [cartItemCount, setCartItemCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUsername = localStorage.getItem('username');

    if (token && storedUsername) {
      setIsLoggedIn(true);
      setUsername(storedUsername);
    }

    const fetchMenuItems = async () => {
      try {
        const response = await axios.get('/configurations/menu');
        const menuData = response.data?.configValue
          ? JSON.parse(response.data.configValue)
          : [];
        setMenuItems(menuData);
      } catch (error) {
        console.error('Error fetching menu:', error);
      }
    };

    const fetchCartCount = async () => {
      if (token) {
        try {
          const response = await axios.get('/carts/count', {
            headers: { Authorization: `Bearer ${token}` },
          });
          const count = response.data.count || 0;
          setCartItemCount(count);
          if (onCartUpdate) {
            onCartUpdate(count);
          }
        } catch (error) {
          console.error('Error fetching cart count:', error);
          setCartItemCount(0);
        }
      }
    };

    fetchMenuItems();
    fetchCartCount();
  }, [onCartUpdate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    setIsLoggedIn(false);
    setCartItemCount(0);
    navigate('/login');
  };

  return (
    <header className="header-custom">
      <div className="container">
        <nav className="navbar navbar-expand-lg">
          <Link to="/" className="navbar-brand">
            <img
              src={`${process.env.PUBLIC_URL}/images/logo.png`}
              alt="Logo Tân Trí Việt"
              className="img-fluid"
              style={{ maxWidth: '150px' }}
            />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              {menuItems.map((item, index) => (
                <li key={index} className="nav-item">
                  <Link className="nav-link" to={item.link}>
                    {item.title}
                  </Link>
                </li>
              ))}

              {isLoggedIn ? (
                <>
                  <li className="nav-item">
                    <Link className="nav-link cart-icon" to="/cart">
                      {/* Ảnh biểu tượng giỏ hàng */}
                      <img
                        src={`${process.env.PUBLIC_URL}/images/cart-icon.png`} // Đường dẫn tới ảnh icon giỏ hàng
                        alt="Giỏ hàng"
                      />
                      {/* Huy hiệu số lượng sản phẩm */}
                      {cartItemCount > 0 && (
                        <span className="badge">{cartItemCount}</span>
                      )}
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="userDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {username}
                    </a>
                    <ul
                      className="dropdown-menu dropdown-menu-end"
                      aria-labelledby="userDropdown"
                    >
                      <li>
                        <Link className="dropdown-item" to="/profile">
                          Hồ sơ
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/orders">
                          Đơn hàng của tôi
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="/settings">
                          Cài đặt
                        </Link>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={handleLogout}
                        >
                          Đăng xuất
                        </button>
                      </li>
                    </ul>
                  </li>
                </>
              ) : (
                <li className="nav-item">
                  <Link className="nav-link" to="/login">
                    Đăng nhập
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
